import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import ReactHtmlParser from 'react-html-parser';

const Paragraph = ({ innerHTML }) => {
  const parsedHTML = ReactHtmlParser(innerHTML);
  return (
    <>
      <Row>
        <Col
          xs={{
            offset: 2,
            span: 20,
          }}
          md={{ offset: 5, span: 11 }}
        >
          <p className="paragraph">{parsedHTML}</p>
        </Col>
      </Row>
    </>
  );
};

Paragraph.propTypes = {
  innerHTML: PropTypes.shape.isRequired,
};

export default Paragraph;
